export const InventoryFiltersEnum = {
  Search: 'Search',
  FulfillmentCenter: 'FulfillmentCenter'
}

export const InventoryViews = {
  AllView: 'all',
  OnHand: 'On Hand'
}

export const InventoryFiltersMessagesMap = {
  All: 'inventoryFilters.All',
  Search: 'returnsFilters.Search'
}

export const InventoryToFCQtyBasedOnStatus = {
  awaitingQuantity: 'incoming',
  committedQuantity: 'committed',
  fulfillableQuantity: 'fulfillable',
  internalTransferQuantity: 'internal transfer',
  onhandQuantity: 'on hand'
}

export const InventoryToFCTotalQtyBasedOnStatus = {
  totalAwaitingQuantity: 'incoming',
  totalCommittedQuantity: 'committed',
  totalFulfillableQuantity: 'fulfillable',
  totalInternalTransferQuantity: 'internal transfer',
  totalBackorderedQuantity: 'backordered',
  totalExceptionQuantity: 'exception',
  totalOnhandQuantity: 'on hand',
  totalSellableQuantity: 'sellable'
}

export const ActiveStatus = {
  any: 'Any',
  active: 'Active',
  inactive: 'Inactive'
}

export const DefaultInventoryOption = {
  active: 'Active'
}

export const BundleStatus = {
  any: 'Any',
  bundle: 'Bundle',
  inactive: 'NotBundle'
}

export const InventoryExportActions = {
  summary: 'export-summary',
  onHand: 'export-on-hand'
}
